<template>
  <v-form v-model="validate">
    <section class="px-0 px-md-10 row pb-5 mx-0 border-b">
      <div class="col-12 px-4 pb-0">
        <v-text-field
          dense
          outlined
          required
          height="50"
          class="mb-1"
          color="var(--logistic)"
          type="text"
          label="نام و نام خانوادگی نماینده"
          v-model="auth.name"
          :rules="[$utils.validators.required, $utils.validators.onlyFarsi]"
          clearable
        ></v-text-field>
      </div>
      <div class="col-12 px-4 pb-0">
        <v-text-field
          :rules="[$utils.validators.required]"
          append-icon="mdi-chevron-left"
          label="شهر و استان"
          color="var(--logistic)"
          @focus="$emit('handle-place-dialog', 'open')"
          :value="
            selectedCity.city && selectedCity.state + ' - ' + selectedCity.city
          "
          height="50"
          type="text"
          outlined
          required
          dense
        ></v-text-field>
      </div>
      <div class="col-12 px-4 pb-0">
        <v-text-field
          dense
          outlined
          required
          height="50"
          class="mb-1"
          color="var(--logistic)"
          :rules="[$utils.validators.required, $utils.validators.onlyFarsi]"
          v-model="auth.companyName"
          type="text"
          label="نام شرکت"
          clearable
        ></v-text-field>
      </div>
      <div class="col-12 px-4 pb-0">
        <v-text-field
          dense
          outlined
          required
          height="50"
          class="mb-1"
          :rules="[
            $utils.validators.required,
            $utils.validators.onlyNumbers,
            $utils.validators.fixedLength(this.auth.national_id, 11),
          ]"
          v-model="auth.national_id"
          color="var(--logistic)"
          type="number"
          label="شناسه ملی شرکت"
          clearable
        ></v-text-field>
      </div>
      <div class="col-12 px-4 pb-0">
        <v-text-field
          dense
          outlined
          required
          height="50"
          class="mb-1"
          color="var(--logistic)"
          v-model="auth.company_landline"
          :rules="[
            $utils.validators.required,
            $utils.validators.fixedLength(this.auth.company_landline, 11),
          ]"
          type="number"
          label="شماره تماس شرکت ( با کد شهر )"
          clearable
        ></v-text-field>
      </div>
      <div class="col-12 px-4 pb-0">
        <v-textarea
          dense
          outlined
          required
          height="50"
          class="mb-1"
          color="var(--logistic)"
          type="text"
          dir="rtl"
          label="آدرس شرکت"
          v-model="auth.address"
          :rules="[$utils.validators.required, $utils.validators.notEnglish]"
          clearable
        ></v-textarea>
      </div>
      <div class="col-12 px-4 pb-0">
        <v-text-field
          dense
          outlined
          height="50"
          class="mb-1"
          color="var(--logistic)"
          type="text"
          v-model="auth.postal_code"
          label="کدپستی شرکت (اختیاری)"
          :rules="[
            $utils.validators.onlyNumbers,
            $utils.validators.fixedLength(this.auth.postal_code, 10),
          ]"
          clearable
        ></v-text-field>
      </div>
    </section>

    <v-divider class="section-devider"></v-divider>

    <section class="px-0 px-md-10 row pb-5 mx-0 border-t pt-7">
      <div class="col-12 px-4">
        <uploader-card
          title="کارت ملی مدیر‌عامل "
          @set-image="setNationalCardImage"
          @delete-image="deleteNationalCardImage"
          :deletable="true"
          :editable="true"
          :required="true"
        ></uploader-card>
        <div class="medium-emp caption-regular mt-1">
          <v-icon x-small class="px-2">mdi-alert</v-icon>
          <span>تصویر واضحی از کارت ملی خود بارگذاری کنید.</span>
        </div>
      </div>

      <div class="col-12 px-4">
        <uploader-card
          @set-image="setNewspaperImage"
          @delete-image="deleteNewspaperImage"
          :title="`روزنامه رسمی <br> (آخرین تغییرات)`"
          :deletable="true"
          :editable="true"
          :required="true"
        ></uploader-card>
        <div class="medium-emp caption-regular mt-1">
          <v-icon x-small class="px-2">mdi-alert</v-icon>
          <span>تصویر واضحی از روزنامه رسمی بارگذاری کنید.</span>
        </div>
      </div>

      <div class="col-12 px-4">
        <uploader-card
          @set-image="setCompaneyLogoImage"
          @delete-image="deleteCompaneyLogoImage"
          title="تصویر لوگو ( اختیاری )"
          :deletable="true"
          :editable="true"
          :required="false"
        ></uploader-card>
        <div class="medium-emp caption-regular mt-1">
          <v-icon x-small class="px-2">mdi-alert</v-icon>
          <span>تصویر واضحی از تصویر لوگو خود بارگذاری کنید.</span>
        </div>
      </div>
    </section>
  </v-form>
</template>

<script>
import UploaderCard from "../../components/UploaderCard.vue";

export default {
  components: { UploaderCard },
  props: ["selected-city", "auth"],
  data() {
    return {
      validate: false,
    };
  },
  watch: {
    validate(val) {
      this.$emit("handle-validate", val);
    },
  },
  methods: {
    setNationalCardImage(image) {
      this.auth.nationalCard = {
        ...image,
        file: this.blobToFile(image.blob, "nationalCard_image"),
      };
    },
    deleteNationalCardImage() {
      this.auth.nationalCard = null;
    },

    setNewspaperImage(image) {
      this.auth.newspaper_image = {
        ...image,
        file: this.blobToFile(image.blob, "newspaper_image"),
      };
    },
    deleteNewspaperImage() {
      this.auth.newspaper_image = null;
    },

    setCompaneyLogoImage(image) {
      this.auth.logo_image = {
        ...image,
        file: this.blobToFile(image.blob, "company_logo_image"),
      };
    },
    deleteCompaneyLogoImage() {
      this.auth.logo_image = null;
    },

    blobToFile(blob, fileName) {
      const imageType = blob.type.split("/")[1];
      const imageFileName = `${fileName}.${imageType}`;
      return new File([blob], imageFileName);
    },
  },
};
</script>


<style scoped>
.section-devider {
  border: 0.35rem solid #f5f5f5;
}
.border-b {
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.12);
}
.border-t {
  border-top: 0.5px solid rgba(0, 0, 0, 0.12);
}
</style>
